import React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M4 0H5H6V1V4H9H10V5V6H9H6V9V10H5H4V9V6H1H0V5V4H1H4V1V0Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "black",
    fillOpacity: props !== null && props !== void 0 && props.disable ? '0.26' : '0.65'
  }));
}
export default SvgComponent;